import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Home, Lock } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import Seo from "../components/Seo";

const formatErr = (d) => {
  if (!d) return "Something went wrong.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e.msg || JSON.stringify(e)).join(" ");
  return String(d);
};

const AdminLogin = () => {
  const { admin, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (admin) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatErr(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[80vh] grid place-items-center px-5 py-16">
      <Seo title="Admin Login | Satyam Real Estate" description="Admin dashboard login." />
      <div className="w-full max-w-md bg-white rounded-2xl border border-stone-200 p-8 shadow-[0_8px_30px_rgb(0,0,0,0.04)]">
        <div className="flex items-center gap-2.5 mb-6">
          <span className="grid place-items-center w-10 h-10 rounded-xl bg-brand text-white"><Home size={20} /></span>
          <span className="font-heading text-xl text-stone-900">Admin Panel</span>
        </div>
        <h1 className="font-heading text-2xl text-stone-900 mb-1">Welcome back</h1>
        <p className="text-sm text-stone-500 mb-6">Sign in to manage your property listings.</p>
        <form onSubmit={submit} className="space-y-4" data-testid="login-form">
          <div>
            <label className="text-sm font-medium text-stone-700">Email</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="login-email"
              className="mt-1.5 w-full rounded-lg border border-stone-200 px-3.5 py-2.5 text-sm outline-none focus:border-brand" />
          </div>
          <div>
            <label className="text-sm font-medium text-stone-700">Password</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="login-password"
              className="mt-1.5 w-full rounded-lg border border-stone-200 px-3.5 py-2.5 text-sm outline-none focus:border-brand" />
          </div>
          {error && <p className="text-sm text-destructive" data-testid="login-error">{error}</p>}
          <button type="submit" disabled={loading} data-testid="login-submit"
            className="w-full flex items-center justify-center gap-2 rounded-full bg-stone-900 text-white py-3 text-sm font-semibold hover:bg-brand transition-colors disabled:opacity-60">
            <Lock size={16} /> {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
